@if (sendingInvitation$ | async) {
<mat-progress-bar mode="indeterminate" color="accent" />
}
<header mat-dialog-title>
  <mat-icon class="dialog-icon">local_post_office</mat-icon>
  Invite Members
</header>
<app-debugger-group>
  <app-debugger
    [json]="inviteNewMemberForm.valueChanges"
    title="Form Value Changes"
  ></app-debugger>
  <app-debugger
    [json]="inviteNewMemberForm.value"
    title="Form Value"
  ></app-debugger>
  <app-debugger
    [json]="inviteNewMemberForm.errors"
    title="Form Errors"
  ></app-debugger>
  <app-debugger
    [json]="inviteNewMemberForm.errors"
    title="Form Errors"
  ></app-debugger>
  <app-debugger
    [json]="inviteNewMemberForm.controls.inviteeEmails.errors"
    title="Emails Errors"
  ></app-debugger>
  <app-debugger [json]="inviteeEmails$" title="inviteeEmails$"></app-debugger>
</app-debugger-group>
<form [formGroup]="inviteNewMemberForm">
  <div
    mat-dialog-content
    fxLayout="column"
    fxLayoutAlign="center stretch"
    fxLayoutGap="2px"
  >
    <mat-form-field appearance="outline">
      <mat-label>Enter Email(s)</mat-label>
      <app-chips-emails-input
        formControlName="inviteeEmails"
        [separatorKeysCodes]="separatorKeysCodes"
        transformLowercase
      ></app-chips-emails-input>
      <mat-hint
        >Add multiple emails separated by a space/comma/semi-colon</mat-hint
      >
      @if ( inviteNewMemberForm.controls.inviteeEmails?.hasError('required') &&
      inviteNewMemberForm.controls.inviteeEmails.touched ) {
      <mat-error> Enter at least one valid email address. </mat-error>
      } @if ( inviteNewMemberForm.controls.inviteeEmails?.touched &&
      (inviteNewMemberForm.controls.inviteeEmails?.hasError('emailArray') ||
      inviteNewMemberForm.controls.inviteeEmails?.hasError('email')) ) {
      <mat-error> All emails must be valid. </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="projectGrp">
      <mat-label>Select Project Group</mat-label>
      <mat-select formControlName="isAdmin" required>
        <mat-option [value]="true">Administrator</mat-option>
        <mat-option [value]="false">Reviewer</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Message(optional)</mat-label>
      <textarea
        matInput
        placeholder="Comment"
        formControlName="message"
        rows="3"
      >
      </textarea>
    </mat-form-field>
  </div>

  <mat-dialog-actions
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="10px"
  >
    <button
      mat-button
      (click)="cancel()"
      [disabled]="sendingInvitation$ | async"
    >
      CANCEL
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="inviteNewMemberForm.invalid || (sendingInvitation$ | async)"
      (click)="sendInvitation()"
    >
      INVITE
    </button>
  </mat-dialog-actions>
</form>
